import React, { useEffect } from 'react';
import { debounce } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

import {getLabel , validateTextSize, resizeHandler, smallerImage} from '../../utils';
import {useMediaQuery} from "react-responsive";
import HnCarouselHolder from './HnCarouselStyles';
import 'react-multi-carousel/lib/styles.css';

const HnCarousel = (props)=> {

	// lg
	const is769_1024 = useMediaQuery({query: '(min-width: 769px) and (max-width: 1024px)' })
	// medium
	const is1025_ = useMediaQuery({query: '(min-width: 1025px)' })
	const is577_768 = useMediaQuery({query: '(min-width: 577px) and (max-width: 768px)'})
	const isMd = useMediaQuery({query: '(min-width: 421px) and (max-width: 768px)'})
	// sm
	const isSm = useMediaQuery({query: '(max-width: 420px)'})
	const imgSz = is769_1024 ? "lg" : (is577_768||isMd||is1025_) ? "md" : isSm ? "sm" : null;

	useEffect(()=> {
		resizeHandler('.hn-carousel-item');
		
		window.addEventListener('resize', debounce(function() {
			resizeHandler('.hn-carousel-item');
		},300));

		return ()=> window.removeEventListener('resize',()=>resizeHandler('.hn-carousel-item'));
	},[]);

	return (
		<HnCarouselHolder>
			<section className="hn__content" tabIndex="0" aria-label={props.details.title} itemScope="itemscope" itemType='https://schema.org/WPSideBar'>
				<h2	className="hn__Header" itemProp='name'>
					{props.details.title}
					{props.details.seeallbtn && // only if see all button is checked, show the button/link
						<a href={props.details.seeAllUrl} className="seeAllBtn">
							{getLabel("SEEALL")}
							<FontAwesomeIcon icon={ faArrowRight }/>
						</a>
					}
				</h2>
				<ul itemScope="itemscope" itemType="https://schema.org/ItemList">
					{props.items.map((item,i)=> {
						return (
							<li key={i} className="hn-carousel-item" itemProp="itemListElement">
								<div className="header__container">
									<a href={item.url} target={item.openNewTab === "true" ? "_blank" : "_self"} itemProp='url'>
										<img tabIndex="0" src={smallerImage(item.image,imgSz)} alt={item.altImageTxt} itemProp='image'/>
									</a>
								</div>
								<div className="description__container">
									{item.category && (
										<a href={item.categoryURL} target={item.openNewTab === "true" ? "_blank" : "_self"}>
											<h2 itemProp='subjectOf'>{item.category}</h2>
										</a>
									)}
									<a href={item.url} itemProp='url'>
										<p itemProp='description'>
											{ item.title && validateTextSize(item.title, 225) }
											{ item.title && item.title.length > 225 && (
												<span>...</span>
											)}
										</p>
									</a>
								</div>
							</li>
						)
					})}
				</ul>
				{props.details.item.length>4 && props.details.seeallbtn && // only if items are more than 4 and see all button is checked, show the banner/button/link
					<h2	className="hn__Header-bottom">
							<a href={props.details.seeAllUrl} className="seeAllBtn">
								{getLabel("SEEALL")}
								<FontAwesomeIcon icon={ faArrowRight }/>
							</a>
					</h2>
				}
			</section>
		</HnCarouselHolder>
	)
}

export default HnCarousel;